import { Injectable } from '@angular/core';
import { Observable, Subject, of } from 'rxjs';

import { AppConfig } from '../../app.config';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class ObservationsService {

  private urlIwmBackend: string = this.config.backendIwmUri + 'Api/api/TaskObservations';

  private imageTypeOrder: { [type: string]: number } = {};

  constructor(private http: HttpClient,
    private config: AppConfig) {

    this.imageTypeOrder['rgb'] = 0;
    this.imageTypeOrder['rgb_hr'] = 1;
    this.imageTypeOrder['rgb_vhr'] = 2;
    this.imageTypeOrder['nir'] = 3;
    this.imageTypeOrder['nir_hr'] = 4;
    this.imageTypeOrder['pan'] = 5;

  }

  public getObservation(observationId: string): Observable<any> {
    const url = `${this.urlIwmBackend}/GetTaskObservation?observationId=${observationId}`;

    const self = this;

    return this.http.get<any>(url).pipe(
      map(observation => {

        observation.Attachments = observation.Attachments.sort(function (a, b) {
          if (a.Type === b.Type) {
            return a.Timestamp > b.Timestamp ? 1 : -1;
          }

          // First order by known types in wanted order and second by type name for unknown types
          const aOrder = self.imageTypeOrder[a.Type];
          const bOrder = self.imageTypeOrder[b.Type];

          const aCompareType = aOrder === undefined ? a.Type : aOrder.toString();
          const bCompareType = bOrder === undefined ? b.Type : bOrder.toString();

          return aCompareType.localeCompare(bCompareType);
        });

        switch (observation.SourceData) {
          case 's2':
            observation.SourceResolution = 'std'
            break;

          case 'spot':
            observation.SourceResolution = 'hr'
            break;

          case 'vhr':
            observation.SourceResolution = 'vhr'
            break;

          default:
            observation.SourceResolution = '-'

            break;
        }


        return observation;
      })
    );
  }

  public update(targetObservationId: string, newDate: string, newValidity: number): Observable<any> {
    const url = `${this.urlIwmBackend}/UpdateTaskObservation?observationId=${targetObservationId}`;
    const body = {
      ObservationInterpreted: newDate,
      Validity: newValidity
    };

    return this.http.post(url, body);
  }

  public getImage(observationId: string, fileId: string): Observable<any> {
    const url = `${this.urlIwmBackend}/GetImage?observationId=${observationId}&fileId=${fileId}`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'image/png',
      }),
      responseType: 'blob' // This tells angular to parse it as a blob, default is json
    };

    const request = new HttpRequest('GET', url, httpOptions);

    return this.http.request(request);
  }

  public setImageArchivedImage(observationId: string, fileId: string, archived: boolean): Observable<any> {
    const url = `${this.urlIwmBackend}/UpdateTaskObservationImageArchived?observationId=${observationId}&fileId=${fileId}&archived=${archived}`;

    const body = {};

    return this.http.post(url, body);
  }

  public attachedToTask(taskId: string): Observable<any> {
    const url = `${this.config.backendIwmUri}/Api/Tasks?$filter=(Id eq ${taskId})&$select=Id,TaskId,Identifier,Name`;
    return (taskId ? this.http.get(url).pipe(map((res) => { return res['value'].length > 0 ? res['value'][0] : null }))
      : of(null));
  }

}
